import { useState, useRef } from 'react'
import { QRCodeCanvas } from 'qrcode.react'
import { motion, AnimatePresence } from 'framer-motion'
import {
  X,
  Copy,
  Facebook,
  Download,
  MessageCircle,
} from 'lucide-react'
import { formatDateTime } from '@/settings/master'

export default function InviteQRModal({ link, learnerInvite, onClose }) {
  const [copied, setCopied] = useState(false)
  const qrRef = useRef(null)

  const handleCopy = () => {
    navigator.clipboard.writeText(link)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  const handleDownload = () => {
    const canvas = qrRef.current
    if (!canvas) return
    const url = canvas.toDataURL('image/png')
    const a = document.createElement('a')
    a.href = url
    a.download = 'qr-code.png'
    a.click()
  }

  const fb = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`
  const line = `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(link)}`

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.25 }}
        className="fixed inset-0 z-[1050] bg-black/40 backdrop-blur-sm flex items-center justify-center p-4"
      >
        <motion.div
          initial={{ y: 30, scale: 0.96, opacity: 0 }}
          animate={{ y: 0, scale: 1, opacity: 1 }}
          exit={{ y: 30, scale: 0.96, opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="w-full max-w-xs sm:max-w-sm bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col"
        >
          <header className="bg-gray-50 border-b border-gray-200 px-5 py-4 flex items-center justify-between">
            <h2 className="flex items-center gap-2 text-base font-semibold">
              <Copy size={18} /> เชิญเข้ากลุ่มผู้เรียน
            </h2>
            <button onClick={onClose} className="text-gray-500 hover:text-red-500">
              <X size={18} />
            </button>
          </header>

          <section className="px-6 py-5 flex flex-col items-center gap-4">
            <QRCodeCanvas
              ref={qrRef}
              value={link}
              size={220}
              level="H"
              includeMargin
            />
            <div className="text-center">
              <h3 className="font-semibold">{learnerInvite.group_name}</h3>
              <p className="text-xs text-gray-600 mt-1">
                สิ้นสุด : {formatDateTime(learnerInvite.expire_at)}
              </p>
            </div>

            <div className="flex w-full max-w-xs rounded-md border border-gray-200 overflow-hidden">
              <input
                readOnly
                value={link}
                className="flex-1 px-3 py-2 text-xs border-none focus:outline-none"
              />
              <button
                onClick={handleCopy}
                className="bg-primary hover:bg-secondary text-white text-sm px-3 flex items-center"
              >
                {copied ? 'คัดลอกแล้ว!' : <Copy size={16} />}
              </button>
            </div>

            <div className="flex gap-4">
              <button onClick={handleDownload} title="ดาวน์โหลด QR">
                <Download
                  size={22}
                  className="text-primary hover:text-primary/80"
                />
              </button>
              <a
                href={fb}
                target="_blank"
                rel="noreferrer"
                title="แชร์ไป Facebook"
              >
                <Facebook
                  size={22}
                  className="text-primary hover:text-primary/80"
                />
              </a>
              <a href={line} target="_blank" rel="noreferrer" title="แชร์ไป LINE">
                <MessageCircle
                  size={22}
                  className="text-primary hover:text-primary/80"
                />
              </a>
            </div>
          </section>

          <footer className="px-6 py-4 border-t border-gray-200 flex justify-end">
            <button
              onClick={onClose}
              className="bg-gray-200 hover:bg-gray-300 text-gray-800 text-sm font-semibold rounded-lg px-4 py-2"
            >
              ปิด
            </button>
          </footer>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  )
}
